import { JSX } from 'react'

import { IconProps } from '../../icon'

const Send: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M37.7378 20.3887L13.1054 10.2749C12.4408 10.0031 11.7113 9.93089 11.0063 10.067C10.3012 10.2032 9.65114 10.5417 9.13543 11.0414C8.62164 11.5137 8.26019 12.1283 8.09717 12.8068C7.93416 13.4854 7.97697 14.1971 8.22015 14.8513L11.4236 23.5006C11.4171 23.5729 11.4171 23.6457 11.4236 23.718C11.4171 23.7903 11.4171 23.8631 11.4236 23.9354L8.22015 32.5847C7.97697 33.2389 7.93416 33.9506 8.09717 34.6291C8.26019 35.3077 8.62164 35.9223 9.13543 36.3946C9.81166 37.0573 10.7171 37.4343 11.6639 37.4471C12.1585 37.4475 12.6484 37.3503 13.1054 37.1611L37.7378 27.0473C38.4051 26.783 38.9776 26.3242 39.3809 25.7306C39.7843 25.1369 40 24.4357 40 23.718C40 23.0003 39.7843 22.2991 39.3809 21.7054C38.9776 21.1118 38.4051 20.653 37.7378 20.3887ZM10.68 12.6889C10.9447 12.4261 11.3023 12.2781 11.6753 12.277C11.868 12.2773 12.0586 12.3162 12.2359 12.3914L36.9026 22.5053L37.017 22.5739H13.5631L10.371 14.0389C10.2786 13.8093 10.2586 13.5568 10.3138 13.3155C10.3691 13.0742 10.4968 12.8555 10.68 12.6889ZM12.2359 35.0445C11.9764 35.1553 11.6897 35.1862 11.4126 35.1332C11.1354 35.0802 10.8803 34.9458 10.68 34.7471C10.4968 34.5805 10.3691 34.3618 10.3138 34.1205C10.2586 33.8792 10.2786 33.6267 10.371 33.397L13.5631 24.8621H37.017L36.8912 24.9307L12.2359 35.0445Z'
      fill='black'
    />
  </svg>
)

export default Send
